import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class DataFieldSectionsDB extends GenericDB {
  constructor(clinicId) {
    super('', 'clinicSettings.dataFieldSections');
    this.clinicId = clinicId;
  }

  async setClinicId(clinicId) {
    this.clinicId = clinicId;
  } // setClinicId()

  getCollectionRef() {
    return collection(db, 'clinicSettings', this.clinicId, 'dataFieldSections');
  }
}
